import querystring from 'querystring';
import ReactGA4 from 'react-ga4';

import { shorthex2ascii } from './string';

const qObj = querystring.parse(window.location.search.slice(1));

export const SWITCH_USE_NONCE_DEFAULT = qObj._disable_nonce !== 'true';
/* switch: _force_jsign */
export const SWITCH_FORCE_JS_SIGN = qObj[shorthex2ascii('5f666f7263655f6a7369676e')] === 'true';
/* switch: _force_wsgin */
export const SWITCH_FORCE_WASM_SIGN = qObj[shorthex2ascii('5f666f7263655f777367696e')] === 'true';
/* switch: _sign_v2_1 */
export const SWITCH_SIGN_V2_1 = qObj[shorthex2ascii('5f7369676e5f76325f31')] === 'true';
export const SWITCH_SIGN_FIELD_POSITION = (qObj._switch_sign_pos || 'headers') as
  | 'headers'
  | 'query';

export const SIGN_HDS = [
  /* 'x-api-ts' */ shorthex2ascii('782d6170692d7473'),
  /* 'x-api-nonce' */ shorthex2ascii('782d6170692d6e6f6e6365'),
  /* 'x-api-ver' */ shorthex2ascii('782d6170692d766572'),
  /* 'x-api-sign' */ shorthex2ascii('782d6170692d7369676e'),
] as const;

export function isSupportWasm() {
  try {
    if (typeof WebAssembly === 'object' && typeof WebAssembly.instantiate === 'function') {
      const module = new WebAssembly.Module(
        Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00),
      );
      if (module instanceof WebAssembly.Module)
        return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
    }
  } catch (e) {}
  return false;
}

let UAL = window.navigator.userAgent.toLowerCase();
/**
 * @description test it with UA `Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) HeadlessChrome/104.0.0.0 Safari/537.36`
 */
export function isHeadlessBrowser() {
  return (
    UAL.includes(
      /* headlesschrome */
      shorthex2ascii('686561646c6573736368726f6d65'),
    ) ||
    /* headless */
    UAL.includes(shorthex2ascii('686561646c657373'))
  );
}

export function isCrawlersBrowser() {
  function docHasAttr(shorthex: string) {
    return window[shorthex2ascii('646f63756d656e74') as any].hasOwnProperty(
      shorthex2ascii(shorthex),
    );
  }
  function winHasAttr(shorthex: string) {
    return window.hasOwnProperty(shorthex2ascii(shorthex));
  }

  const docAttrs = [
    /* __webdriver_evaluate */ '5f5f7765626472697665725f6576616c75617465',
    /* __selenium_evaluate */ '5f5f73656c656e69756d5f6576616c75617465',
    /* __webdriver_script_function */ '5f5f7765626472697665725f7363726970745f66756e6374696f6e',
    /* __webdriver_script_func */ '5f5f7765626472697665725f7363726970745f66756e63',
    /* __webdriver_script_fn */ '5f5f7765626472697665725f7363726970745f666e',
    /* __fxdriver_evaluate */ '5f5f66786472697665725f6576616c75617465',
    /* __driver_unwrapped */ '5f5f6472697665725f756e77726170706564',
    /* __webdriver_unwrapped */ '5f5f7765626472697665725f756e77726170706564',
    /* __driver_evaluate */ '5f5f6472697665725f6576616c75617465',
    /* __selenium_unwrapped */ '5f5f73656c656e69756d5f756e77726170706564',
    /* __fxdriver_unwrapped */ '5f5f66786472697665725f756e77726170706564',
  ];

  if (docAttrs.some(da => docHasAttr(da))) return true;

  const winAttrs = [
    /* '_phantom' */ '5f7068616e746f6d',
    /* '__phantomas' */ '5f5f7068616e746f6d6173',
    /* '__nightmare' */ '5f5f6e696768746d617265',
    /* '_selenium' */ '5f73656c656e69756d',
    /* '_Selenium_IDE_Recorder' */ '5f53656c656e69756d5f4944455f5265636f72646572',
    /* 'callPhantom' */ '63616c6c5068616e746f6d',
    /* 'callSelenium' */ '63616c6c53656c656e69756d',
  ];

  if (winAttrs.some(wa => winHasAttr(wa))) return true;

  return false;
}

// uncomment lines below to test on development
// if (process.env.NODE_ENV === 'development') {
//     (document as any).__webdriver_evaluate = Function;
//     (window as any)._phantom = Function;
// };

export const IS_SUPPORT_WASM = isSupportWasm();
const IS_CRAWLERS_BROWSER = isCrawlersBrowser();
let IS_HEADLESS_BROWSER = isHeadlessBrowser();

export function securityFeatGA() {
  ReactGA4.event({
    category: 'SecurityFeature',
    action: 'IsSupportWasm',
    label: IS_SUPPORT_WASM ? 'True' : 'False',
  });

  ReactGA4.event({
    category: 'SecurityFeature',
    action: 'IsHeadless',
    label: IS_HEADLESS_BROWSER ? 'True' : 'False',
  });

  ReactGA4.event({
    category: 'SecurityFeature',
    action: 'IsCrawlers',
    label: IS_CRAWLERS_BROWSER ? 'True' : 'False',
  });
}

let REQUEST_SOURCE = IS_HEADLESS_BROWSER
  ? shorthex2ascii('686561646c657373') /* headless */
  : IS_CRAWLERS_BROWSER
    ? shorthex2ascii('756e6b6e6f776e') /* unknown */
    : shorthex2ascii('776562'); /* 'web' */
export function getRequestSource() {
  return REQUEST_SOURCE;
}

setInterval(() => {
  UAL = window.navigator.userAgent.toLowerCase();
  IS_HEADLESS_BROWSER = UAL.includes(shorthex2ascii('686561646c657373'));
  REQUEST_SOURCE = IS_HEADLESS_BROWSER
    ? shorthex2ascii('686561646c657373') /* headless */
    : IS_CRAWLERS_BROWSER
      ? shorthex2ascii('756e6b6e6f776e') /* unknown */
      : shorthex2ascii('776562') /* 'web' */;

  if (IS_HEADLESS_BROWSER || IS_CRAWLERS_BROWSER) {
    delete (globalThis as any)[shorthex2ascii('5f5f64626b5f684e4844')];
  }
}, 3000);

const H = window.location.hostname;

/* setup those methods according to requirement from @debank/isomorphic */
/* __dbk_hNHD */
(globalThis as any)[shorthex2ascii('5f5f64626b5f684e4844')] = (host: string, host2: string) => {
  return (
    H.includes(shorthex2ascii('646562616e6b2e636f6d')) /* debank.com */ ||
    H.includes(
      shorthex2ascii('646562616e6b65722e76657263656c2e617070'),
    ) /* debanker.vercel.app */ ||
    process.env.NODE_ENV !== 'production'
  );
};

// variable would be deleted if some methods in `@debank/isomorphic/es/sign-js-mainsite` called
/* __ggn */
(globalThis as any)[shorthex2ascii('5f5f67676e')] = () => {
  /* debank.com */
  return shorthex2ascii('646562616e6b2e636f6d');
};
